import { render, staticRenderFns } from "./resourceList.vue?vue&type=template&id=2a1dde2c&scoped=true"
import script from "./resourceList.vue?vue&type=script&lang=js"
export * from "./resourceList.vue?vue&type=script&lang=js"
import style0 from "./resourceList.vue?vue&type=style&index=0&id=2a1dde2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1dde2c",
  null
  
)

export default component.exports